module.exports = __webpack_public_path__ + "static/media/pic9.8e2de7f2.jpg";